import { render, staticRenderFns } from "./notificationBar.vue?vue&type=template&id=795cec06&scoped=true&"
import script from "./notificationBar.vue?vue&type=script&lang=js&"
export * from "./notificationBar.vue?vue&type=script&lang=js&"
import style0 from "./notificationBar.vue?vue&type=style&index=0&id=795cec06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795cec06",
  null
  
)

export default component.exports